import { createSharedComposable, useBreakpoints as useBreakpointsVueUse } from '@vueuse/core';

/**
 * @description Composable that prepares breakpoints-dependent refs
 * @returns {@link ReturnType<typeof useBreakpoints>}
 * @example
 * const { isMobile, isTablet, isDesktop, isMaxWidth } = useBreakpoints();
 */
export const useBreakpoints = createSharedComposable(() => {
  const breakpoints = useBreakpointsVueUse({
    desktop: '1024px',
    maxWidth: '1366px',
    tablet: '768px',
  });

  const isMobile = computed(() => breakpoints.smaller('tablet').value);
  const isTablet = computed(() => breakpoints.greaterOrEqual('tablet').value);
  const isDesktop = computed(() => breakpoints.greaterOrEqual('desktop').value);
  const isMaxWidth = computed(() => breakpoints.greaterOrEqual('maxWidth').value);

  return {
    isDesktop,
    isMaxWidth,
    isMobile,
    isTablet,
  };
});
